import { TableRow } from '@tiptap/extension-table-row'

export default TableRow.extend({
  allowGapCursor: false,
  content: '(tableCell | tableHeader)*',
})
